import React from 'react'
import { Edit } from 'react-admin'
import SectionWrapper from 'ui-shared/LayoutComponents/SectionWrapper'
import DrinkPackageForm from './DrinkPackageForm'

const DrinkPackageEdit: React.FC = () => {
  return (
    <SectionWrapper title={'resources.drinkpackages.editPackage'}>
      <Edit>
        <DrinkPackageForm />
      </Edit>
    </SectionWrapper>
  )
}

export default DrinkPackageEdit
